// バリエーションの表示・非表示
const selectVariant = document.querySelector('#product-variant-id');
selectVariant.addEventListener('change', changeVariant);
function changeVariant() {
  const variantId = document.querySelector('#product-variant-id');
  // バリエーションの数量を非表示
  hiddenVariant();
  // バリエーションの数量を表示
  displayVariant(variantId.value);
  // 選択したバリエーション名の表示
  changedSelectedVariantName();
}

// バリエーションの数量を非表示
function hiddenVariant() {
  const variantTrs = document.querySelectorAll('.product__variant-tr');
  for (var i = 0; i < variantTrs.length; i++) {
    if (!variantTrs[i].classList.contains('hidden')) {
      variantTrs[i].classList.toggle('hidden');
      variantTrs[i].querySelector('select').setAttribute('disabled', true);
      break;
    }
  }
}
// バリエーションの数量を表示
function displayVariant(variantId) {
  const variantClassName = '.product-variant-' + variantId;
  const displayVariant = document.querySelector(variantClassName);
  displayVariant.classList.toggle('hidden');
  displayVariant.querySelector('select').removeAttribute('disabled');
}
// 選択したバリエーション名の表示
function changedSelectedVariantName() {
  const selectVariant = document.querySelector('#product-variant-id :checked');
  const selectVariantTitle = selectVariant.dataset.title;
  const selectedVariant = document.querySelector('#workshop-variant .select__area-label');
  selectedVariant.innerHTML = selectVariantTitle;
}
